import type { Database } from "@repo/api-types";
import { createBrowserClient } from "@supabase/ssr";
import { createClient } from "@supabase/supabase-js";

// Get environment variables with validation
const getSupabaseConfig = () => {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
  const serviceRoleKey = process.env.SUPABASE_SERVICE_ROLE_KEY;

  if (!url || !anonKey) {
    throw new Error("Missing required Supabase environment variables. Please set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY");
  }

  return { url, anonKey, serviceRoleKey };
};

const { url, anonKey, serviceRoleKey } = getSupabaseConfig();

// Client-side Supabase client with cookie-based session persistence.
// Uses @supabase/ssr so tokens live in cookies — the same cookies that
// middleware and server components read. This eliminates the need for
// manual session syncing via onAuthStateChange.
export const supabase = createBrowserClient<Database>(url, anonKey);

// Server-side admin client (service role)
export const supabaseAdmin = createClient<Database>(
  url,
  serviceRoleKey || anonKey // Fallback to anon key if service role not available
);
